import { render, staticRenderFns } from "./CashRegisterManagement.vue?vue&type=template&id=38f808f0&scoped=true&"
import script from "./CashRegisterManagement.vue?vue&type=script&lang=js&"
export * from "./CashRegisterManagement.vue?vue&type=script&lang=js&"
import style0 from "./CashRegisterManagement.vue?vue&type=style&index=0&id=38f808f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f808f0",
  null
  
)

export default component.exports